// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The editor tracker token.
 */
export const IEditorTracker = new Token('@jupyterlab/fileeditor:IEditorTracker', `A widget tracker for file editors.
  Use this if you want to be able to iterate over and interact with file editors
  created by the application.`);
//# sourceMappingURL=tokens.js.map